import axios from '@axios'

const getDefaultState = () => ({
  status: null,
  users: [],
})

export default {
  namespaced: true,
  state: getDefaultState,
  getters: {},
  mutations: {
    SET_STATUS(state, payload) {
      state.status = payload
    },
    SET_USERS(state, payload) {
      state.users = payload
    },
    ADD_USER(state, payload) {
      state.users.push(payload)
    },
    UPDATE_USER(state, payload) {
      state.users = state.users.map(user => (user.id === payload.id ? payload : user))
    },
    DELETE_USER(state, id) {
      state.users = state.users.filter(user => user.id !== id)
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async getStatus({ commit }, siteId) {
      const { data } = await axios.get(`/site/${siteId}/back-to-home`)
      commit('SET_STATUS', data.data)

      return data.data
    },
    async enable({ commit }, siteId) {
      const { data } = await axios.post(`/site/${siteId}/back-to-home`)
      commit('SET_STATUS', data.data)

      return data.data
    },
    async disable({ commit }, siteId) {
      const { data } = await axios.delete(`/site/${siteId}/back-to-home`)
      commit('SET_STATUS', data.data)
      commit('SET_USERS', [])

      return data.data
    },
    async getUsers({ commit }, siteId) {
      try {
        const { data } = await axios.get(`/site/${siteId}/back-to-home/users`)
        commit('SET_USERS', data.data)

        return data.data
      } catch (error) {
        commit('SET_USERS', [])
        return Promise.reject(error)
      }
    },
    async createUser({ commit }, { siteId, payload }) {
      const { data } = await axios.post(`/site/${siteId}/back-to-home/users`, payload)
      commit('ADD_USER', data.data)

      return data.data
    },
    async updateUser({ commit }, { siteId, id, payload }) {
      const { data } = await axios.put(`/site/${siteId}/back-to-home/users/${id}`, payload)
      commit('UPDATE_USER', data.data)

      return data.data
    },
    async setUserEnabled({ commit }, { siteId, id, isEnabled }) {
      const { data } = await axios.put(`/site/${siteId}/back-to-home/users/${id}/${isEnabled ? 'enable' : 'disable'}`)
      commit('UPDATE_USER', data.data)

      return data.data
    },
    async deleteUser({ commit }, { siteId, id }) {
      await axios.delete(`/site/${siteId}/back-to-home/users/${id}`)
      commit('DELETE_USER', id)
    },
    // The config holds the user's private key, so it is handed to the caller and never kept in the store.
    async getUserConfig(context, { siteId, id }) {
      const { data } = await axios.get(`/site/${siteId}/back-to-home/users/${id}/config`)

      return data.data
    },
  },
}
